import React, {useState} from 'react';
import {Button} from '@components/elements/button';
import {LocalizedText} from '@components/elements/localizedText';
import styles from './styles.scss';
import {useTranslation} from 'react-i18next';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import {Input} from '@components/elements/input';
import config from '@config';
import {toast} from 'react-hot-toast';

export const RemoveAccountRequest = () => {

    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    // const [email, setEmail] = useState('');
    const [showErrors, setShowErrors] = useState(false);

    const [requestStatus, setRequestStatus] = useState<'waiting'|'requested'|'success'>('waiting');

    const {t} = useTranslation('login');

    const isLoginValid = () => login.length >= 1;
    const isPasswordValid = () => password.length >= 1;
    // const isEmailValid = () => /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);

    const isFormValid = () => isLoginValid() && isPasswordValid();

    const sendRequest = () => {
        if (isFormValid()) {
            setRequestStatus('success');
            toast.success(t('success.descriptionRemoveRequest'));
        } else {
            setShowErrors(true);
            setRequestStatus('waiting');
        }
    };

    if(requestStatus == 'success'){
        return <div className={styles.successInfoWindow}>
            <img src={require('_assets/img/demoAccess/success.png')} alt="" />
            <div className={styles.title}>
                <LocalizedText path='login' name='success.titleRemoveRequest'/>
            </div>
            <div>
                <LocalizedText path='login' name='success.descriptionRemoveRequest'/>
            </div>
            <Button className={styles.button} onClick={() => location.href = config.path.login.main}>
                <LocalizedText path='login' name='buttons.ok'/>
            </Button>
        </div>;
    }

    return <div>

        <div className={styles.form}>
            <div className={styles.title}>
                <LocalizedText path='login' name='form.titleRemoveRequest'/>
            </div>
            <div className={styles.description}>
                <LocalizedText path='login' name='form.descriptionRemoveRequest'/>
            </div>
            <div className={styles.formElements}>
                <Input value={login} onChange={e => setLogin(e.target.value)} placeholder={t('placeholders.login')} error={showErrors && !isLoginValid()} errorText={t('errors.inputLogin')}/>
                <Input value={password} type='password' onChange={e => setPassword(e.target.value)} placeholder={t('placeholders.password')} error={showErrors && !isPasswordValid()} errorText={t('errors.inputPassword')}/>
                {/* <Input value={email} onChange={e => setEmail(e.target.value)} placeholder={t('placeholders.email')} error={showErrors && !isEmailValid()} errorText={t('errors.inputEmail')}/> */}
                <Button className={styles.submitButton} onClick={sendRequest} disabled={requestStatus == 'requested'}>
                    <LocalizedText path='login' name='buttons.sendRemoveRequest'/>
                </Button>
            </div>
        </div>
    </div>;
};
